import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { iconoirNavArrowLeft } from '@ng-icons/iconoir';
import { Route } from '../../../utils/route';
import { DictionaryService } from '../../../services/dictionary.service';
import { TabsComponent } from '../../../components/tabs/tabs.component';
import { SupervisorNfaTabComponent } from './nfa-tab/nfa-tab.component';
import { SupervisorSingleVisitTabComponent } from './single-visit-tab/single-visit-tab.component';
import { SupervisorDoubleVisitsTabComponent } from './double-visits-tab/double-visits-tab.component';
import { SupervisorActivitiesCalendarTabComponent } from './activities-calendar-tab/activities-calendar-tab.component';

@Component({
  selector: 'app-supervisor-details',
  imports: [
    NgIcon,
    TabsComponent,
    SupervisorNfaTabComponent,
    SupervisorSingleVisitTabComponent,
    SupervisorDoubleVisitsTabComponent,
    SupervisorActivitiesCalendarTabComponent,
  ],
  providers: [provideIcons({ iconoirNavArrowLeft })],
  templateUrl: './supervisor-details.component.html',
  styleUrl: './supervisor-details.component.scss',
})
export class SupervisorDetailsComponent extends Route implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  protected dictionaryService = inject(DictionaryService);

  userId = signal<string>('');
  userName = signal<string>('');
  defaultTab = signal<string>('');

  get userInitial(): string {
    const name = this.userName();
    return name ? name.charAt(0).toUpperCase() : '?';
  }

  private storageKey(id: string): string {
    return `supervisor_name_${id}`;
  }

  ngOnInit(): void {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state || history.state;
    const nameFromState = state?.['userName'] as string | undefined;

    this.route.params.subscribe((params) => {
      const id = params['id'] || '';
      this.userId.set(id);

      if (nameFromState) {
        this.userName.set(nameFromState);
        localStorage.setItem(this.storageKey(id), nameFromState);
      } else {
        const saved = localStorage.getItem(this.storageKey(id));
        if (saved) this.userName.set(saved);
      }
    });

    this.route.queryParams.subscribe((params) => {
      this.defaultTab.set(params['tab'] || '');
    });
  }

  onTabChange(tab: string): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  goBack(): void {
    this.router.navigate(['/supervisors']);
  }
}
